import type { GroupStyleI } from "tweenly"
import ColorPickerInput from "../ColorPickerInput"
import ImageInput from "../ImageInput"
import NumberInput from "../NumberInput"
import SelectInput from "../SelectInput"
import ShadowInput from "../ShadowInput"
import TextInput from "../TextInput"

interface Props {
    groupStyle: GroupStyleI
    handleOnChange: (field: "value", value: any) => void
    handleSetStyleValue?: (property: any, value: any) => void
    handleSetAttributeValue?: (property: any, value: any) => void
}

const GroupFieldValue = ({
    groupStyle,
    handleOnChange,
    handleSetStyleValue,
    handleSetAttributeValue,
}: Props) => {
    // GroupFieldRow decides which of these sit beside the type and which take a row
    const handleFieldOnChange = (e: any) => handleOnChange("value", e.target.value)

    if (groupStyle.input.type === "number") {
        return <NumberInput styleProperty={groupStyle} handleOnChange={handleFieldOnChange} />
    } else if (groupStyle.input.type === "string" && groupStyle.property !== "linearGradient") {
        return <TextInput styleProperty={groupStyle} handleOnChange={handleFieldOnChange} />
    } else if (groupStyle.input.type === "select") {
        return <SelectInput styleProperty={groupStyle} handleOnChange={handleFieldOnChange} />
    } else if (groupStyle.property === "linearGradient") {
        return (
            <TextInput
                fullWidth={true}
                styleProperty={groupStyle}
                handleOnChange={handleFieldOnChange}
            />
        )
    } else if (
        groupStyle.input.type === "image" &&
        handleSetStyleValue &&
        handleSetAttributeValue
    ) {
        return (
            <ImageInput
                styleProperty={groupStyle}
                handleOnChange={handleFieldOnChange}
                handleSetStyleValue={handleSetStyleValue}
                handleSetAttributeValue={handleSetAttributeValue}
            />
        )
    } else if (groupStyle.input.type === "color" && handleSetStyleValue) {
        return (
            <ColorPickerInput
                styleProperty={groupStyle}
                // handleOnChange={(e: any) => handleSetStyleValue(e.target.name, e.target.value)}
                handleOnChange={handleFieldOnChange}
            />
        )
    } else if (groupStyle.input.type === "shadow") {
        return <ShadowInput styleProperty={groupStyle} handleOnChange={handleFieldOnChange} />
    } else return <></>
}

export default GroupFieldValue
